import { KYMW4001Component } from './kymw4001.component';

/**
 * プロモーションマスタ一覧画面の値を管理するクラス
 *
 * @export KYMW4001Model
 * @class KYMW4001Model
 */
export class KYMW4001Model {

  kymw4001Component: KYMW4001Component;

  public promotionList: Array<any> = new Array<any>();                          // プロモーションマスタ一覧

  public btnOutputEnabled = Boolean(false);                            // 出力ボタン活性フラグ

  /**
   * プロモーションマスタ一覧更新
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW4001Model
   */
  public outputPromotionList(data: any): void {
    // プロモーションマスタ一覧を保持
    if (data == null) {                          // 該当データなしの場合
      // プロモーションマスタ一覧
      this.promotionList = new Array<any>();

      // 出力ボタンの活性・非活性制御
      this.btnOutputEnabled = false;
    } else {                                                                    // 該当データありの場合
      // プロモーションマスタ一覧
      const tempList = data;
      // PromotionNoを数値型に変換
      for (let i = 0; i < tempList.length; i++) {
        tempList[i].PromotionNo = Number(tempList[i].PromotionNo);
      }

      this.promotionList = tempList;

      // 出力ボタンの活性・非活性制御
      this.btnOutputEnabled = true;
    }
  }

}
